//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ReportFormat } from './Enums';

export class StudentPortalRepertoireReportSettings extends ItemBase {
    StudentID: string | null = null;
    RepertoireIDs: string[] = [];
    IncludeNotes: boolean = false;
    ShowDuration: boolean = false;
    Format: ReportFormat = ReportFormat.PDF;
    Note: string | null = null;

    constructor(initializer?: Partial<StudentPortalRepertoireReportSettings>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentPortalRepertoireReportSettings";
}
